import { TimeHelper } from '../../utils';
import { CalendarEvent } from './types';

export function isBreakpoint(eventMinutes: number, breakpointMinutes: 5 | 10 | 15 | 20 | 25 | 30 | 45 | 60 | 120) {
  return eventMinutes >= breakpointMinutes;
}

export function getDayViewTimeRange(
  dateUnix: number, // start of day
  calendarEvents: CalendarEvent[],
  workingHours: { from: number; to: number },
  timezone: string,
): { min: Date; max: Date } {
  const dateString = TimeHelper.getDateStringTz(dateUnix, timezone);
  const startOfDayUnix = TimeHelper.getStartOfDayLocal(dateString);

  const storeOpeningTime = TimeHelper.setMinutesLocal(startOfDayUnix, workingHours.from || 0);
  const storeClosingTime = TimeHelper.setMinutesLocal(startOfDayUnix, workingHours.to || 0);

  const timeRange = {
    min: storeOpeningTime,
    max: storeClosingTime,
  };

  calendarEvents.forEach((calendarEvent) => {
    if (calendarEvent.start && calendarEvent.start.getTime() < timeRange.min) {
      timeRange.min = calendarEvent.start.getTime();
    }

    if (calendarEvent.end && calendarEvent.end.getTime() > timeRange.max) {
      timeRange.max = calendarEvent.end.getTime();
    }
  });

  const endOfDayUnix = TimeHelper.getEndOfDayLocal(dateString);

  timeRange.min = TimeHelper.getStartOfHourLocal(timeRange.min - 60 * 60000);
  timeRange.max = TimeHelper.getStartOfHourLocal(timeRange.max + 60 * 60000);

  if (timeRange.min < startOfDayUnix) {
    timeRange.min = startOfDayUnix;
  }

  if (timeRange.max > endOfDayUnix) {
    timeRange.max = endOfDayUnix;
  }

  return {
    min: new Date(timeRange.min),
    max: new Date(timeRange.max),
  };
}
